import initMobileNav from './modules/mobile-nav';
import initMainNav from './modules/main-nav';
import initFadeIn from './modules/fade-in';
import initPostSlider from './modules/post-slider';
import initFeaturedLinks from './modules/featured-links';
import initImageCarousel from './modules/image-carousel';
import initImageContent from './modules/image-content';
import initCountUp from './modules/count-up';
import initProjects from './modules/projects';
import initSearch from './modules/search';

initMobileNav();
initMainNav();
initFadeIn();
initPostSlider();
initFeaturedLinks();
initImageCarousel();
initImageContent();
initCountUp();
initProjects();
initSearch();
